import { render } from "./NotificationDetailModal.vue?vue&type=template&id=616457d7&scoped=true"
import script from "./NotificationDetailModal.vue?vue&type=script&lang=js"
export * from "./NotificationDetailModal.vue?vue&type=script&lang=js"

import "./NotificationDetailModal.vue?vue&type=style&index=0&id=616457d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616457d7"]])

export default __exports__